import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PrivacyPolicy() {
  const { t } = useTranslation("global");

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">{t('privacy.title')}</h2>
      <p className="text-center mb-5">{t('privacy.subtitle')}</p>

      <div className="mb-4">
        <h4>{t('privacy.data.title')}</h4>
        <p>{t('privacy.data.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('privacy.usage.title')}</h4>
        <p>{t('privacy.usage.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('privacy.sharing.title')}</h4>
        <p>{t('privacy.sharing.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('privacy.security.title')}</h4>
        <p>{t('privacy.security.description')}</p>
      </div>
    </div>
  );
}
